import React from 'react';
import axios from 'axios';
import history from '../history';
import toastr from 'toastr';
import _ from 'lodash';
import store from '../store';
import {
  getMyRegion
} from '../ultil.js';
import {
  setGlobalVariable
} from '../store/action/globalVariableAction';
const urlNeedMembeToken = []
export const post = (url, body={}) => {
  if (!body.regionName) {
    body.regionName = getMyRegion()
  }

  if (!body.token && _.get(store.getState(), 'globalVariable.token', '')) {
    body.token = _.get(store.getState(), 'globalVariable.token', '')
  }

  if (_.get(store.getState(), 'globalVariable.memberToken', '')) {
    body.memberToken = _.get(store.getState(), 'globalVariable.memberToken', '')
  }

  return  new Promise(function(resolve, reject) {
    axios.post(url, body)
      .then(res=>handleRespone(res, resolve, reject))
      .catch(e=>{
        reject(e)
      })
  });
}

export const postFormData = (options) =>{
  return  new Promise(function(resolve, reject) {
    axios(options)
      .then(res=>handleRespone(res, resolve, reject))
      .catch(e=>{
        reject(e)
      })
  });
}

const handleRespone = (res, resolve, reject) => {
  let code = _.get(res, 'data.code')
  let head = _.get(res, 'data.message.head')
  let body = _.get(res, 'data.message.body')
  let msg = _.get(res, 'data.msg')
  let updateToken = _.get(res, 'data.user.memberToken')
  let isRefresh = _.get(res, 'data.user.isRefresh')
  let memberToken = _.get(store.getState(), 'globalVariable.memberToken', '')
  if (updateToken && (!memberToken || (isRefresh && memberToken !== updateToken))) {
    store.dispatch(setGlobalVariable({memberToken: updateToken}))
  }
  let type = null
  switch (code) {
    case 200:
      type = 'success'
    break;
    case 300:
      type = 'warning'
    break;
    case 500:
      type = 'error'
    break;
    case 1993:
      type = 'info'
      axios.get('/logout')
    break;
    default:
  }
  if ((head || body || msg) && type ) {
    toastr[type](body || msg, head)
  }
  if(code === 200 || !code) {
    resolve(res.data)
  } else {
    reject(res.data)
  }
}
